import PropTypes from 'prop-types';

const MainLayoutPropType = {
  children: PropTypes.node,
};

export default MainLayoutPropType;
